export default __webpack_public_path__ + "static/media/example_1.2dcbc618.png";